exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mr10{\n  margin-right: 10px;\n}\n", ""]);

// exports
